export default "__VITE_ASSET__Cx_3aLGX__"